import { COUNTRIES, REGIONS } from '@/constants';

export interface RegionOption {
  id: number;
  name: string;
}

export interface CountryOption {
  id: number;
  name: string;
  region_id: number;
}

export function getRegionIdByName(
  regionName: string,
  regions: RegionOption[] = REGIONS
): number {
  const normalized = (regionName || '').trim();
  if (!normalized) return -1;
  const region = regions.find((r) => r.name === normalized);
  return region ? region.id : -1;
}

export function getCountriesForRegionName(
  regionName: string,
  countries: CountryOption[] = COUNTRIES,
  regions: RegionOption[] = REGIONS
): CountryOption[] {
  const regionId = getRegionIdByName(regionName, regions);
  if (!regionName || regionId === -1) return [];
  return countries.filter((c) => c.region_id === regionId);
}

export function sanitizeCountryForRegion(
  countryName: string,
  regionName: string,
  countries: CountryOption[] = COUNTRIES,
  regions: RegionOption[] = REGIONS
): string {
  const normalizedCountry = (countryName || '').trim();
  if (!normalizedCountry) return '';

  const allowed = getCountriesForRegionName(regionName, countries, regions);
  const stillValid = allowed.some((c) => c.name === normalizedCountry);
  return stillValid ? normalizedCountry : '';
}
